import { AssetType, ClipTranscodingState } from '@/types/assets'

export const contentSortByOrder = (content1: { order: number }, content2: { order: number }) => {
  return content1.order < content2.order ? -1 : 1
}


export interface SceneContent {
  active: boolean,
  box: string,
  id: string,
  idx?: number,
  position?: number,
  url?: string,
  state?: ClipTranscodingState,
  name: string,
  order: number,
  type: AssetType,
  leftMuted?: boolean,
  rightMuted?: boolean,
  muted?: boolean,
  isDefault?: boolean, // = added to a layout, appears default in scene
  user?: string,
  simplecgText?: string,
  auto_play_next?: boolean
}
